import * as React from "react";
import * as S from "./messageRowImprove.styled";
import { BookPlus } from "lucide-react";
import { usePromptLibraryContext } from "@/modules/promptLibrary/promptLibrary.context";

interface Props {
  content: string;
}

export const OpenChatMessageRowAddToPromptLibrary: React.FC<Props> = ({ content }) => {
  const { openCreatePromptLibraryModal } = usePromptLibraryContext();

  const handleImprovePrompt = () => {
    openCreatePromptLibraryModal(content, "open_chat");
  };

  return (
    <S.Container className="mt-1 flex rounded-md p-1 text-xs text-white" onClick={handleImprovePrompt}>
      <BookPlus size={14} className="mr-1" />
      Add to library
    </S.Container>
  );
};
